import React from "react";
import "./VehicleBox.scss";
import { Box, Link } from "@mui/material";
import AccessAlarmOutlinedIcon from "@mui/icons-material/AccessAlarmOutlined";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";

interface Props {
  regno: string;
  vehicleType: string;
  nofdays: string;
  makeModel: string;
  variant: string;
}

const VehicleBox: React.FC<Props> = ({
  regno,
  vehicleType,
  nofdays,
  makeModel,
  variant,
}) => {
  return (
    <Box className="vehicleDetailBox">
      <div className="regno">{regno}</div>
      <div className="noofDays">
        <AccessAlarmOutlinedIcon /> {nofdays}
      </div>
      <div className="myVehicle">
        <div className={vehicleType}></div>
        <div className="vehicleInfo">
          <h5>{makeModel}</h5>
          <p>{variant}</p>
        </div>
      </div>
      <Link className="renew">
        <AutorenewOutlinedIcon /> Renew
      </Link>
    </Box>
  );
};

export default VehicleBox;
